import { styled } from '@mui/material/styles';
import { Typography } from '@raisin/components-lib';
import GridContainer from '@mui/material/Container';

export const BannerContainer = styled('div')(({ theme }) => ({
  position: 'relative',
  display: 'flex',
  width: '100%',
  minHeight: '370px',
  justifyContent: 'space-between',
  background: 'linear-gradient(90deg, rgb(43, 43, 43) 0%, rgb(43, 105, 159) 100%)',

  [theme.breakpoints.down('lg')]: {
    flexDirection: 'column-reverse',
    justifyContent: 'flex-end',
  },
}));

export const BannerContent = styled(GridContainer)(({ theme }) => ({
  padding: theme.spacing(20, 6, 20, 6),

  [theme.breakpoints.down('lg')]: {
    padding: theme.spacing(8, 6, 20, 6),
  },
}));

export const TitleText = styled(Typography)(({ theme }) => ({
  maxWidth: '70%',

  [theme.breakpoints.down('lg')]: {
    maxWidth: '100%',
  },

  [theme.breakpoints.down('sm')]: {
    fontSize: theme.typography.h4.fontSize,
  },
}));

export const SubtitleContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  marginTop: theme.spacing(2),
  alignItems: 'center',

  [theme.breakpoints.down('lg')]: {
    marginTop: theme.spacing(4),
  },
}));

export const SubtitleText = styled(Typography)(({ theme }) => ({
  ...theme.typography.body1,
  wordBreak: 'break-word',
  maxWidth: '70%',

  '& span': {
    fontWeight: theme.typography.h2.fontWeight,
  },

  [theme.breakpoints.down('lg')]: {
    maxWidth: '100%',
  },

  [theme.breakpoints.down('sm')]: {
    ...theme.typography.h4,
  },
}));

export const ListContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  paddingTop: theme.spacing(10),
  flexDirection: 'column',
  gap: theme.spacing(3),
}));

export const ListItem = styled('div')(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(2.5),
}));

export const ListItemText = styled(Typography)(({ theme }) => ({
  ...theme.typography.body1,
  fontWeight: 600,
  wordBreak: 'break-word',

  [theme.breakpoints.down('sm')]: {
    ...theme.typography.h4,
  },
}));

export const LGCircleContent = styled('div')(({ theme }) => ({
  width: '25%',
  height: '100%',
  position: 'absolute',
  right: 0,
  backgroundColor: theme.palette.white.main,
}));

export const LGCircle = styled('div')(({ theme }) => ({
  position: 'absolute',
  right: 0,
  display: 'flex',
  height: '100%',
  justifyContent: 'left',
  alignItems: 'center',
  paddingLeft: '30%',
  backgroundColor: theme.palette.white.main,
  left: '-180px',
  clipPath: 'circle(43% at 43% 50%)',

  '& img': {
    objectFit: 'contain',
  },

  [theme.breakpoints.down('xl')]: {
    left: '-120px',
    clipPath: 'circle(70% at 70% 50%)',
  },
}));

export const SMCircle = styled('div')({
  position: 'relative',
  width: '100%',
  height: '180px',

  '& svg path': {
    transform: 'scaleX(1.1) translateX(-5%)',
  },
});

export const SMLogoContainer = styled('div')`
  position: absolute;
  bottom: 30%;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
`;

export const Logo = styled('img')`
  width: 200px;
`;

export const CheckmarkIcon = styled('img')`
  width: 24px;
  height: 24px;
`;
